import { usePermission } from '@fs/zion-permissions'
import topics from '../components/topics'

export default function useTopicTabs() {
  const [isMember] = usePermission('MemberContentPermission', 'DiscoveryUserContext')
  const baseTopics = [topics.stories, topics.feed]
  const memberTopics = [...baseTopics, topics.temple, topics.activities, topics.more]
  const nonMemberTopics = [...baseTopics, topics.activities, topics.more]

  return isMember ? memberTopics : nonMemberTopics
}
